import { render, staticRenderFns } from "./SettingsCreateOrganisation.vue?vue&type=template&id=ffe75d42&scoped=true"
import script from "./SettingsCreateOrganisation.vue?vue&type=script&lang=js"
export * from "./SettingsCreateOrganisation.vue?vue&type=script&lang=js"
import style0 from "./SettingsCreateOrganisation.vue?vue&type=style&index=0&id=ffe75d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe75d42",
  null
  
)

export default component.exports